import React from "react";
import StatusBadge from "./StatusBadge";
import PriorityBadge from "./PriorityBadge";
import ProgressBar from "./ProgressBar";
import { isOverdue } from "./reportingStyles";

function Row({ label, children }) {
  return (
    <div className="flex items-start justify-between gap-4 py-2.5 text-sm">
      <span className="shrink-0 text-slate-400">{label}</span>
      <span className="text-right font-medium text-slate-800">{children}</span>
    </div>
  );
}

function ActivityDetailBody({ task }) {
  if (!task) return null;
  const overdue = isOverdue(task);
  const note = task.note?.trim();

  return (
    <div className="px-1 py-1">
      <p className="mb-4 text-base font-semibold text-slate-900">
        {task.description || "—"}
      </p>
      <div className="divide-y divide-slate-100 rounded-lg border border-slate-100 bg-slate-50/50 px-4">
        {task.user?.name && <Row label="Employee">{task.user.name}</Row>}
        <Row label="Priority">
          <PriorityBadge priority={task.priority} />
        </Row>
        <Row label="Status">
          <StatusBadge status={task.status} />
        </Row>
        {task.progress_percent != null && (
          <Row label="Progress">
            <ProgressBar
              value={task.progress_percent || 0}
              status={task.status}
              width="w-24"
            />
          </Row>
        )}
        <Row label="Due date">
          <span>
            {task.due_date || "—"}
            {overdue && (
              <span className="ml-2 rounded bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-600">
                Overdue
              </span>
            )}
          </span>
        </Row>
      </div>
      <div className="mt-4">
        <p className="mb-2 text-[10px] font-semibold uppercase tracking-wide text-slate-400">
          Notes
        </p>
        <div className="daily-report-notes-cell max-h-[240px] overflow-y-auto rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-xs text-slate-700 whitespace-pre-wrap break-words leading-relaxed">
          {note || "No notes added."}
        </div>
      </div>
    </div>
  );
}

export default ActivityDetailBody;
